import type { CustomField } from '../../groups/types';
import type { ItemFieldEntry } from '../../items/utils/get-item-fields';
import { KIT_SYSTEM_FIELDS } from '../types';

interface GetKitFieldsParams {
	customFields?: CustomField[];
}

export const getKitFields = ({ customFields = [] }: GetKitFieldsParams = {}): ItemFieldEntry[] => [
	...KIT_SYSTEM_FIELDS,
	...customFields.map((field) => ({ ...field, id: `fields.${field.name}` })),
];
